/*****************************************************************************/
/*  File Name: upgradeRow.js                                                 */
/*  Date:      Sept 02, 2025                                                 */
/*  Author:    Ben Wakutz                                                    */
/*  Purpose:   This is the bar that will show the logos                      */
/*             for the upgrade systems                                       */
/*                                                                           */
/*****************************************************************************/

import React from 'react';
import { withTranslation } from 'react-i18next';

//import styles from './styles/roi.module.scss';
import { Grid } from '@mui/material';
import * as TIMERANGE from '../../constants/timeRanges';
import * as MODES from '../../constants/modes';
import { useROIContext } from '../../context/roiContext';
import { useSystemContext } from '../../context/systemContext';
import styles from './styles/roi.module.scss';
import { G } from '@react-pdf/renderer';

function UpgradeRow({ t }) {
  //Load all of the default component varaibles

  const { oldSystem, upgradeSystem } = useSystemContext()
  //console.log('this is my oldSystem --->', oldSystem);
   //console.log('this is my upgradeSystem --->', upgradeSystem);

  return (
    <div className={styles.timeRangeSelectWrapperUpgrade}>
      <Grid item xs={12} container className={styles.upgradeRow}>
        <Grid item xs={6} className={styles.title} container gap={2} alignItems="center">
            <Grid item>
              {oldSystem?.logo ? <img src={oldSystem.logoURL} alt={oldSystem.name} id={oldSystem.id} className={styles.brandLogo} /> : ''}
            </Grid>
            <Grid item >
              Treatments
            </Grid>
        </Grid>
        <Grid item xs={6} className={styles.title} container gap={2} alignItems="center">
           <Grid item >
              {upgradeSystem?.logo ? <img src={upgradeSystem.logoURL} alt={upgradeSystem.name} id={upgradeSystem.id} className={styles.brandLogo} /> : ''}
            </Grid>
            <Grid item >
              Potential Treatments
            </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

export default withTranslation()(UpgradeRow);